export default function resizeImage(url = "", width = 768, height = 0) {
  url = url.replace(
    "https://s3.amazonaws.com/a-us.storyblok.com/",
    "https://a-us.storyblok.com/",
  );
  return url ? `${url}/m/${width}x${height}` : "";
}
